<template>
    <v-container
        fill-height
        style="height: calc(100vh - 58px);"
    >
        <v-layout align-center>
            <v-flex text-center>
                <h1 class="text-h3 primary--text">Whoops, 404</h1>
                <p>The page you were looking for does not exist</p>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>

</style>
